export const NEW_VIEW = 'new';
export const NEW_VIEW_TEMPLATE_NAME = 'New View';
export const AUTO_GENERATED_TEMPLATE_NAME = 'Auto generated';
export const PERSONAL_VIEW_NAME = 'Personal view';
